import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { ClickableIcon } from 'atoms';
import { RatingStarSvg } from 'components/icons';
import { FlexCenterWrapper, Mr3 } from 'wrappers';
import getIsMobile from "components/atoms/utils/getIsMobile"

const isMobile = getIsMobile();

export const definition = {
  name: 'Rating',
  controller: Controller,
  initialProps: ({ rating }) => ({ rating }),
  props: internalState,
  elements: [
    {
      component: wrap(ClickableIcon, Mr3),
      name: 'Star',
      isListOf: { currentStar: ({ }) => ([1, 2, 3, 4, 5]) },
      displayValue: ({ currentStar, rating }) => RatingStarSvg({ width: isMobile ? 35 : 44, height: isMobile ? 35 : 44, filled: currentStar <= rating }),
      bindings: ({ currentStar }) => ({ currentStar })
    }
  ]
};

export default wrap(ContainerComponent(definition), FlexCenterWrapper);
